import event4 from '../../images/event/1.png'
import event5 from '../../images/event/2.png'

import './style.css'

const CulturalHighlightsSection = (props) => {

    return (
        <div className="event-area section-padding">
            <div className="container">

                {/* Section Title */}
                <div className="row">
                    <div className="col-lg-6 offset-lg-3">
                        <div className="section-title section-title2 text-center">
                            <div className="thumb-text">
                                <span>OUR FOCUS</span>
                            </div>
                            <h2>Celebrating Culture, Rhythm & Expression</h2>
                            <p>
                               <b> Nardhanamala centre for performing arts foundation</b> celebrates India’s timeless performing arts by blending
                                traditional values with a modern vision — nurturing creativity, discipline,
                                and cultural pride in every dancer and musician.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Decorative Shapes */}
            <div className="shape1"><img src={event4} alt="decoration" /></div>
            <div className="shape2"><img src={event5} alt="decoration" /></div>
        </div>
    )
}

export default CulturalHighlightsSection
